import { subDays, subHours } from 'date-fns'

import { isMockingEnabled } from '@/lib/constants'

import { toUTCISOString } from '@/shared/datetime/utils/format'

import type { ResolvedTimeRange } from '@/shared/opensearch/utils/time-preset'

/**
 * The Log Search window used when the URL carries no valid `tr`. The one
 * owner of the default: the route's `beforeLoad` fills it, and the picker
 * falls back to it.
 *
 * Product default is `now − 1h` (recent activity, the sane SIEM default). But
 * the mock world seeds its log pool anchored to load-time `now`, spanning ~1h
 * to ~31d old (ADR 0007 padded-case bound = −31d) — a 1-hour window misses ALL
 * of it, so an out-of-the-box search dead-ends on zero hits. Whenever mocking
 * is on (`dev:mock` OR the demo build — the single `isMockingEnabled` gate) we
 * widen to 32d so the window provably covers the whole seeded pool. Both seed
 * and window anchor to the same `now`, so the intersection is invariant;
 * 32d < the mock SKU's 90d search limit, so the picker's SKU disableFn never
 * clamps it.
 *
 * @param now Defaults to the current time. Pass a fixed Date in tests.
 */
export const defaultSearchTimeRange = (
	now: Date = new Date(),
): ResolvedTimeRange => ({
	st: toUTCISOString(isMockingEnabled ? subDays(now, 32) : subHours(now, 1)),
	ed: toUTCISOString(now),
})
